<section [formGroup]="formGroup">

    <re-captcha *ngIf="question.options.typeSpecificOptions && question.options.typeSpecificOptions.key" (resolved)="resolved($event)" siteKey="{{question.options.typeSpecificOptions.key}}"></re-captcha>
    
    <mat-form-field appearance="outline" class="always-hidden">
        <input type="text" matInput [formControlName]="controlName">
    </mat-form-field>
</section>